module.exports = __webpack_public_path__ + "img/pubgm-personage.5163f02.png";